import { render, staticRenderFns } from "./StakedNfts.vue?vue&type=template&id=2c639d6b&scoped=true&"
import script from "./StakedNfts.vue?vue&type=script&lang=js&"
export * from "./StakedNfts.vue?vue&type=script&lang=js&"
import style0 from "./StakedNfts.vue?vue&type=style&index=0&id=2c639d6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c639d6b",
  null
  
)

export default component.exports